import { TimesheetConfigurationModelParsed, TimesheetConfigurationModelRaw } from './types';
import { getSettlementType, getSettlementTypeRawApiFormat } from '@/app/services/contract/settlementTypeResolver';

type Props = {
  companyId: string
}

export function parseTimesheetBasicSettings(model: TimesheetConfigurationModelRaw) : TimesheetConfigurationModelParsed {
  return {
    ...model,
    settlementPeriods: model.settlementPeriods.map((sp) => ({
      ...sp,
      settlementType: getSettlementType(sp.settlementType),
    }))
  }
}

export function mapTimesheetBasicSettingsParsedToRaw(
  model: TimesheetConfigurationModelParsed
): TimesheetConfigurationModelRaw {
  return {
    ...model,
    settlementPeriods: model.settlementPeriods.map(sp => ({
      ...sp,
      settlementType: getSettlementTypeRawApiFormat(sp.settlementType),
    })),
  }
}
